module.exports = __webpack_public_path__ + "img/IMG-4845.224f8c1d.jpg";